/** Icones du menu "sandwich" de coin, reprises telles quelles de dkg-farkle pour garder la meme apparence entre les deux jeux. */

/** Bouton "sandwich" qui replie tous les autres boutons de coin. */
export const MENU_ICON_SVG = `
  <svg viewBox="0 0 24 24" width="1.1em" height="1.1em" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round">
    <line class="ham-top" x1="4" y1="7" x2="20" y2="7" />
    <line class="ham-mid" x1="4" y1="12" x2="20" y2="12" />
    <line class="ham-bot" x1="4" y1="17" x2="20" y2="17" />
  </svg>`;

export const RULES_ICON_SVG = `
  <svg viewBox="0 0 24 24" width="1.1em" height="1.1em" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
    <path d="M4.5 5.3c1.6-.9 4.3-.9 6 0v13.4c-1.7-.9-4.4-.9-6 0V5.3Z" stroke-linejoin="round" />
    <path d="M19.5 5.3c-1.6-.9-4.3-.9-6 0v13.4c1.7-.9 4.4-.9 6 0V5.3Z" stroke-linejoin="round" />
  </svg>`;

/** Icone porte/sortie en ligne fine (or), dessinee a la main plutot qu'un emoji pour rester dans le style grave des autres pastilles. */
export const QUIT_ICON_SVG = `
  <svg viewBox="0 0 24 24" width="1.1em" height="1.1em" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
    <path d="M13 4H6.8C6.36 4 6 4.36 6 4.8v14.4c0 .44.36.8.8.8H13" />
    <path d="M10.5 12h9.5" />
    <path d="M16.5 8.5 20 12l-3.5 3.5" />
  </svg>`;

/** Roue dentee (cog), reprise de dkg-farkle. */
export const OPTIONS_ICON_SVG = `
  <svg viewBox="0 0 24 24" width="1.1em" height="1.1em" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
    <circle cx="12" cy="12" r="5" />
    <circle cx="12" cy="12" r="1.8" />
    <rect x="11" y="4" width="2" height="3.4" rx="0.5" />
    <rect x="11" y="4" width="2" height="3.4" rx="0.5" transform="rotate(45 12 12)" />
    <rect x="11" y="4" width="2" height="3.4" rx="0.5" transform="rotate(90 12 12)" />
    <rect x="11" y="4" width="2" height="3.4" rx="0.5" transform="rotate(135 12 12)" />
    <rect x="11" y="4" width="2" height="3.4" rx="0.5" transform="rotate(180 12 12)" />
    <rect x="11" y="4" width="2" height="3.4" rx="0.5" transform="rotate(225 12 12)" />
    <rect x="11" y="4" width="2" height="3.4" rx="0.5" transform="rotate(270 12 12)" />
    <rect x="11" y="4" width="2" height="3.4" rx="0.5" transform="rotate(315 12 12)" />
  </svg>`;

/** Bulle de parole (commentaires du Taverneu), reprise de dkg-farkle. */
export const TAVERNEU_ICON_SVG = `
  <svg viewBox="0 0 24 24" width="1.3em" height="1.3em" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
    <path d="M4 5.5h16v10H9.5L6 19v-3.5H4Z" stroke-linejoin="round" />
    <path d="M8 9.5h8M8 12.2h5" />
  </svg>`;

/** Ampoule (conseil de l'assistant strategique). */
export const ASSISTANT_ICON_SVG = `
  <svg viewBox="0 0 24 24" width="1.1em" height="1.1em" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
    <path d="M9 18h6" />
    <path d="M10 21h4" />
    <path d="M12 3a6 6 0 0 0-3.2 11.1c.6.4 1 1 1.1 1.7l.1.7h4l.1-.7c.1-.7.5-1.3 1.1-1.7A6 6 0 0 0 12 3Z" />
  </svg>`;

/** Flamme (qualite graphique / chandelles). */
export const GRAPHICS_ICON_SVG = `
  <svg viewBox="0 0 24 24" width="1.3em" height="1.3em" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
    <path d="M12 2.5c1 2.3-2.4 3.6-2.4 6.4 0 1 .5 1.7 1 2.2-.7-1.6.3-2.7 1-3.6.2 1 .9 1.5 1.4 2.2.6.8 1 1.6 1 2.7 0 2.6-2.2 4.6-4.9 4.4a4.7 4.7 0 0 1-4.1-5.2C4.4 7.4 8.9 6 12 2.5Z" stroke-linejoin="round" />
  </svg>`;

/** Cible/reticule (aide de previsualisation des deplacements). */
export const MOVE_HINTS_ICON_SVG = `
  <svg viewBox="0 0 24 24" width="1.3em" height="1.3em" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
    <circle cx="12" cy="12" r="7" />
    <circle cx="12" cy="12" r="2.4" />
    <path d="M12 2v3.4M12 18.6V22M2 12h3.4M18.6 12H22" />
  </svg>`;

/** Grille d'applications (bouton "Autres jeux"), reprise de dkg-farkle. */
export const OTHER_GAMES_ICON_SVG = `
  <svg viewBox="0 0 24 24" width="1.1em" height="1.1em" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
    <rect x="4" y="4" width="7" height="7" rx="1" />
    <rect x="13" y="4" width="7" height="7" rx="1" />
    <rect x="4" y="13" width="7" height="7" rx="1" />
    <rect x="13" y="13" width="7" height="7" rx="1" />
  </svg>`;

/** Maison (retour a la page racine du site multi-jeux). */
export const HOME_ICON_SVG = `
  <svg viewBox="0 0 24 24" width="1.1em" height="1.1em" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
    <path d="M4 10.5 12 4l8 6.5" />
    <path d="M6 10v9h12v-9" />
    <path d="M10 19v-5h4v5" />
  </svg>`;
